var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('title-row', {
    attrs: {
      "title": _vm.page.title,
      "subtitle": _vm.page.subtitle,
      "breadcrumb-items": [{
        text: 'Adminisztátorok',
        to: {
          name: 'UserList'
        }
      }, _vm.page.breadcrumbItem]
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c('title-row-button', {
          on: {
            "click": _vm.impersonate
          }
        }, [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-domino-mask")]), _vm._v(" Megeszemélyesítés ")], 1), _c('title-row-button', {
          attrs: {
            "loading": _vm.loading
          },
          on: {
            "click": _vm.save
          }
        }, [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-check")]), _vm._v(" Mentés ")], 1)];
      },
      proxy: true
    }])
  }), _vm.loading ? _c('loading-overlay') : _vm._e(), _c('v-tabs', {
    attrs: {
      "align-tabs": "center",
      "color": "text--primary"
    },
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tabs-slider', {
    attrs: {
      "color": "primary"
    }
  }), _c('v-tab', {
    key: "general"
  }, [_vm._v("Általános")]), _c('v-tab', {
    key: "filters"
  }, [_vm._v("Szűrők")]), _c('v-tabs-items', {
    staticClass: "pa-2",
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', {
    key: "general"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": 12,
      "md": 6
    }
  }, [_vm.form.user.apiuser ? _c('v-card', {
    staticClass: "rounded-xl",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-account")]), _vm._v("Alapadatok")], 1), _c('v-card-text', [_c('v-masked-text-field', {
    attrs: {
      "label": "Név",
      "error-messages": _vm.errors.name,
      "mask": _vm.$config.inputMasks.name,
      "filled": ""
    },
    model: {
      value: _vm.form.user.name,
      callback: function ($$v) {
        _vm.$set(_vm.form.user, "name", $$v);
      },
      expression: "form.user.name"
    }
  }), _c('v-masked-textarea', {
    attrs: {
      "label": "API kulcs",
      "error-messages": _vm.errors.name,
      "mask": _vm.$config.inputMasks.name,
      "filled": "",
      "rows": "1",
      "auto-grow": ""
    },
    model: {
      value: _vm.form.user.apikey,
      callback: function ($$v) {
        _vm.$set(_vm.form.user, "apikey", $$v);
      },
      expression: "form.user.apikey"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "Lejárat dátuma",
      "readonly": "",
      "filled": ""
    },
    model: {
      value: _vm.form.user.apikey_expire,
      callback: function ($$v) {
        _vm.$set(_vm.form.user, "apikey_expire", $$v);
      },
      expression: "form.user.apikey_expire"
    }
  })], 1)], 1) : _c('v-card', {
    staticClass: "rounded-xl",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-account")]), _vm._v("Alapadatok")], 1), _c('v-card-text', [_c('v-autocomplete', {
    attrs: {
      "label": "Címtáras keresés",
      "search-input": _vm.dnSearchText,
      "items": _vm.dnSearchItems,
      "item-text": "text",
      "item-value": "id",
      "loading": _vm.dnLoading,
      "filled": ""
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.dnSearchText = $event;
      },
      "update:search-input": function ($event) {
        _vm.dnSearchText = $event;
      }
    },
    model: {
      value: _vm.dnSelected,
      callback: function ($$v) {
        _vm.dnSelected = $$v;
      },
      expression: "dnSelected"
    }
  }), _c('v-masked-text-field', {
    attrs: {
      "label": "Név",
      "error-messages": _vm.errors.name,
      "mask": _vm.$config.inputMasks.name,
      "filled": ""
    },
    model: {
      value: _vm.form.user.name,
      callback: function ($$v) {
        _vm.$set(_vm.form.user, "name", $$v);
      },
      expression: "form.user.name"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "Email",
      "error-messages": _vm.errors.email,
      "filled": ""
    },
    model: {
      value: _vm.form.user.email,
      callback: function ($$v) {
        _vm.$set(_vm.form.user, "email", $$v);
      },
      expression: "form.user.email"
    }
  }), _c('v-masked-text-field', {
    attrs: {
      "label": "Jelszó",
      "error-messages": _vm.errors.password,
      "filled": "",
      "mask": _vm.$config.inputMasks.password,
      "append-icon": _vm.showPass ? 'mdi-eye' : 'mdi-eye-off',
      "type": _vm.showPass ? 'text' : 'password',
      "autocomplete": "new-password"
    },
    on: {
      "click:append": function ($event) {
        _vm.showPass = !_vm.showPass;
      }
    },
    model: {
      value: _vm.form.user.password,
      callback: function ($$v) {
        _vm.$set(_vm.form.user, "password", $$v);
      },
      expression: "form.user.password"
    }
  }), _c('v-masked-text-field', {
    attrs: {
      "label": "Jelszó Újra",
      "error-messages": _vm.errors.password_,
      "filled": "",
      "mask": _vm.$config.inputMasks.password,
      "append-icon": _vm.showPassAgain ? 'mdi-eye' : 'mdi-eye-off',
      "type": _vm.showPassAgain ? 'text' : 'password',
      "autocomplete": "new-password"
    },
    on: {
      "click:append": function ($event) {
        _vm.showPassAgain = !_vm.showPassAgain;
      }
    },
    model: {
      value: _vm.form.user.password_,
      callback: function ($$v) {
        _vm.$set(_vm.form.user, "password_", $$v);
      },
      expression: "form.user.password_"
    }
  })], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": 12,
      "md": 6
    }
  }, [_c('v-card', {
    staticClass: "rounded-xl",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-key-chain")]), _vm._v("Engedélyek")], 1), _c('v-card-text', [_c('v-switch', {
    attrs: {
      "label": "QR kód beállítás fix 24 óra"
    },
    model: {
      value: _vm.form.user.barcode_period_fix,
      callback: function ($$v) {
        _vm.$set(_vm.form.user, "barcode_period_fix", $$v);
      },
      expression: "form.user.barcode_period_fix"
    }
  }), _c('v-select', {
    attrs: {
      "filled": "",
      "label": "QR kód igénylés csoportok",
      "items": _vm.usertype_groups,
      "item-text": "name",
      "item-value": "element_id",
      "multiple": "",
      "chips": ""
    },
    model: {
      value: _vm.form.user.barcode_request_groups,
      callback: function ($$v) {
        _vm.$set(_vm.form.user, "barcode_request_groups", $$v);
      },
      expression: "form.user.barcode_request_groups"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('v-tab-item', {
    key: "filters"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-card', {
    staticClass: "rounded-xl",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-shield-key-outline")]), _vm._v("Jogosultságok ")], 1), _c('v-card-text', [_vm.errors.rights ? _c('v-alert', {
    attrs: {
      "type": "error",
      "dense": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.errors.rights[0]) + " ")]) : _vm._e(), _c('v-treeview', {
    ref: "rightsTree",
    attrs: {
      "items": _vm.form.rights,
      "selection-type": "leaf",
      "selectable": "",
      "return-object": "",
      "selected-color": "primary",
      "shaped": "",
      "transition": "",
      "hoverable": "",
      "multiple-active": "",
      "dense": ""
    },
    on: {
      "input": _vm.rightsInputHandler
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function (_ref) {
        var item = _ref.item,
          open = _ref.open;
        return [_c('v-icon', [_vm._v(" " + _vm._s(item.children ? open ? 'mdi-folder-open-outline' : 'mdi-folder-key-outline' : 'mdi-shield-key-outline') + " ")])];
      }
    }, {
      key: "label",
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_vm.errors.rights && item.name == 'Kártya írás' ? _c('span', {
          staticClass: "red"
        }, [_vm._v(" " + _vm._s(item.name) + " ")]) : _c('span', [_vm._v(" " + _vm._s(item.name) + " ")]), _vm.getRightDependencies(item.id) ? _c('span', [_vm._v(" (Felülírja: " + _vm._s(_vm.getRightDependencies(item.id)) + ") ")]) : _vm._e()];
      }
    }]),
    model: {
      value: _vm.selection,
      callback: function ($$v) {
        _vm.selection = $$v;
      },
      expression: "selection"
    }
  })], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-card', {
    staticClass: "rounded-xl",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-filter-variant")]), _vm._v("Elem szűrők ")], 1), _c('v-card-text', [_c('v-switch', {
    attrs: {
      "label": "Csoportképzésnél szűrő"
    },
    model: {
      value: _vm.form.user.filter_element,
      callback: function ($$v) {
        _vm.$set(_vm.form.user, "filter_element", $$v);
      },
      expression: "form.user.filter_element"
    }
  }), _vm.form.user.filter_element ? _c('div', {
    staticClass: "mt-6"
  }, [_vm._v(" Szűrők "), _vm._l(_vm.filter.element_types, function (type) {
    return [_c('v-autocomplete', {
      attrs: {
        "label": type.name,
        "items": _vm.filter.elements[type.id],
        "item-text": "name",
        "item-value": "element_id",
        "value-comparator": _vm.$config.comparators.isEqual,
        "multiple": "",
        "chips": "",
        "return-object": "",
        "filled": ""
      },
      model: {
        value: _vm.form.user.filter_elements[type.id],
        callback: function ($$v) {
          _vm.$set(_vm.form.user.filter_elements, type.id, $$v);
        },
        expression: "form.user.filter_elements[type.id]"
      }
    })];
  })], 2) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }